
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11203",
                "data-name": "矩形 11203",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(262 319)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_243",
        "data-name": "蒙版组 243",
        "class": "cls-2",
        "transform": "translate(-262 -319)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "WLANaccess",
            "transform": "translate(265.36 322.304)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7748",
                "data-name": "路径 7748",
                "class": "cls-3",
                "d": "M274.555,521.529a1.2,1.2,0,1,0,0,2.4,1.2,1.2,0,1,0,0-2.4Zm0-3.84a8.647,8.647,0,0,0-5.022,1.92.728.728,0,0,0-.123.84.641.641,0,0,0,.49.24.456.456,0,0,0,.367-.12,7.32,7.32,0,0,1,4.287-1.68,6.115,6.115,0,0,1,4.165,1.68.6.6,0,0,0,.857,0,.572.572,0,0,0,0-.84A7.685,7.685,0,0,0,274.555,517.689Z",
                "transform": "translate(-265.571 -509.929)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7749",
                "data-name": "路径 7749",
                "class": "cls-3",
                "d": "M165.973,369.778a10.247,10.247,0,0,0-6.955,2.88.592.592,0,0,0-.116.84.679.679,0,0,0,.464.12.417.417,0,0,0,.348-.12,9.3,9.3,0,0,1,6.259-2.52,8.929,8.929,0,0,1,6.144,2.52.547.547,0,0,0,.811,0,.594.594,0,0,0,0-.84A9.836,9.836,0,0,0,165.973,369.778Z",
                "transform": "translate(-156.986 -366.016)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7750",
                "data-name": "路径 7750",
                "class": "cls-3",
                "d": "M76.076,220.018a12.1,12.1,0,0,0-17.68,0,1.086,1.086,0,0,0,0,.84c.113.24.563.24.788,0a10.869,10.869,0,0,1,8.108-3.48,11.049,11.049,0,0,1,8.108,3.48.4.4,0,0,0,.338.12.834.834,0,0,0,.45-.24C76.414,220.618,76.3,220.258,76.076,220.018Z",
                "transform": "translate(-58.311 -216.178)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  